"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Category32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M22.452 2.927c.827 0 1.502.671 1.502 1.491v15.518c0 .669-.333 1.565-.774 2.079l-4.692 5.475c-.562.655-1.504.657-2.067 0l-4.693-5.475c-.437-.51-.774-1.416-.774-2.079V4.418c0-.823.68-1.491 1.503-1.491h9.995zm0 1h-9.995a.501.501 0 00-.503.491v15.518c0 .423.252 1.1.534 1.428l4.692 5.475c.164.19.385.19.548 0l4.693-5.475c.286-.333.533-.999.533-1.428V4.418a.501.501 0 00-.502-.491zm-4.998 17a1 1 0 110 2 1 1 0 010-2zm4-11.5a.5.5 0 110 1h-8a.5.5 0 010-1h8zm0-3a.5.5 0 110 1h-8a.5.5 0 010-1h8z", className: "category-32_svg__path-1" }))); };
var StyledCategory32 = styled_components_1.default(Category32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledCategory32;
var templateObject_1;
//# sourceMappingURL=Category32.js.map